// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3k7OQ","colMin":"styles_colMin__96x2k"};